module.exports = __webpack_public_path__ + "img/PY.1988af76.svg";